<template>
  <div>

    <b-tabs>

      <b-tab 
        v-if="canViewDocumentosCita"
        title="Documentos Cita"
      >

        <b-row class="mx-3">

          <b-col class="d-flex justify-content-end align-text-bottom">
            <b-button 
              variant="outline-primary" 
              :disabled="hasActiveMspLoading"
              @click="redirectToMSP"
            >
              Solicitar MSP
            </b-button>
          </b-col>
        </b-row>
        
        <div
          class="row p-2 mt-2 mb-3 mx-3" 
          style="border: 1px solid #c9c9c9"
        >
          <div class="col-12">

            <div class="row pb-1" style="border-bottom: 1px solid #c9c9c9">
              <h5 class="col-6">Documentos MSP</h5>
            </div>

            <LoadFileInput
              v-if="titularesDocs.length > 0"
              :label="`(Pac) ${titularesDocs[0].nombres}`"
              v-model="citaDocs.mspPaciente"
              :urlFile="urlCitaDocs.urlMspPaciente"
            >
              <template #actions>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="ml-1"
                  :disabled="isMspLoading('mspPaciente')"
                  @click="onMspAutomaticoFor(titularesDocs[0].identificacion, 'mspPaciente')"
                >
                  <b-spinner
                    v-if="isMspLoading('mspPaciente')"
                    small
                    class="mr-1"
                  />
                  {{ isMspLoading('mspPaciente') ? 'Consultando MSP...' : 'MSP Automático' }}
                </b-button>
              </template>
            </LoadFileInput>
            
            <span v-if="titularesDocs.length > 1">
              <hr>
  
              <LoadFileInput
                :label="`(T1) ${titularesDocs[1].nombres}`"
                v-model="citaDocs.mspTitular1"
                :urlFile="urlCitaDocs.urlMspTitular1"
              >
                <template #actions>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="ml-1"
                    :disabled="isMspLoading('mspTitular1')"
                    @click="onMspAutomaticoFor(titularesDocs[1].identificacion, 'mspTitular1')"
                  >
                    <b-spinner
                      v-if="isMspLoading('mspTitular1')"
                      small
                      class="mr-1"
                    />
                    {{ isMspLoading('mspTitular1') ? 'Consultando MSP...' : 'MSP Automático' }}
                  </b-button>
                </template>
              </LoadFileInput>
            </span>
            
            <span v-if="titularesDocs.length > 2">
              <hr>
  
              <LoadFileInput
                :label="`(T2) ${titularesDocs[2].nombres}`"
                v-model="citaDocs.mspTitular2"
                :urlFile="urlCitaDocs.urlMspTitular2"
              >
                <template #actions>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="ml-1"
                    :disabled="isMspLoading('mspTitular2')"
                    @click="onMspAutomaticoFor(titularesDocs[2].identificacion, 'mspTitular2')"
                  >
                    <b-spinner
                      v-if="isMspLoading('mspTitular2')"
                      small
                      class="mr-1"
                    />
                    {{ isMspLoading('mspTitular2') ? 'Consultando MSP...' : 'MSP Automático' }}
                  </b-button>
                </template>
              </LoadFileInput>
            </span>


            <span v-if="titularesDocs.length > 3">
              <hr>
  
              <LoadFileInput
                :label="`(T3) ${titularesDocs[3].nombres}`"
                v-model="citaDocs.mspTitular3"
                :urlFile="urlCitaDocs.urlMspTitular3"
              >
                <template #actions>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="ml-1"
                    :disabled="isMspLoading('mspTitular3')"
                    @click="onMspAutomaticoFor(titularesDocs[3].identificacion, 'mspTitular3')"
                  >
                    <b-spinner
                      v-if="isMspLoading('mspTitular3')"
                      small
                      class="mr-1"
                    />
                    {{ isMspLoading('mspTitular3') ? 'Consultando MSP...' : 'MSP Automático' }}
                  </b-button>
                </template>
              </LoadFileInput>
            </span>


          </div>

        </div>


        <div 
          class="row p-2 my-3 mx-3" 
          style="border: 1px solid #c9c9c9"
        >

          <div class="col-12">

            <span v-if="stDataCita && stDataCita.esDerivado">
              <LoadFileInput
                label="Tirilla"
                v-model="citaDocs.tirilla"
                :urlFile="urlCitaDocs.urlTirilla"
              />
  
            
              <hr>

              <LoadFileInput
                label="Documento Derivacion"
                v-model="citaDocs.derivacion"
                :urlFile="urlCitaDocs.urlDerivacion"
              />


              <hr>
              
              <LoadFileInput
                label="Formulario 007"
                v-model="citaDocs.f007"
                :urlFile="urlCitaDocs.urlF007"
              />
            </span>
  

            <span v-if="stDataCita && stDataCita.tipoServicios.includes('2')">
              <hr>

              <LoadFileInput
                label="Solicitud de imagen derivada"
                v-model="citaDocs.solicitudImagen"
                :urlFile="urlCitaDocs.urlSolicitudImagen"
              />

            </span>
  
            
            <span v-if="stDataCita && stDataCita.tipoServicios.includes('3')">
              <hr>

              <LoadFileInput
                label="Solicitud de laboratorio derivado"
                v-model="citaDocs.solicitudLaboratorio"
                :urlFile="urlCitaDocs.urlSolicitudLaboratorio"
              />
    
            </span>
  
            
            <span v-if="stDataCita && stDataCita.tipoServicios.includes('4')">
              <hr>

              <LoadFileInput
                label="Solicitud de procedimiento derivado"
                v-model="citaDocs.solicitudProcedimiento"
                :urlFile="urlCitaDocs.urlSolicitudProcedimiento"
              />
            </span>

            <span>
              <hr>

              <LoadFileInput
                label="Otros documentos"
                v-model="citaDocs.otrosDocs"
                :urlFile="urlCitaDocs.urlOtrosDocs"
              />
            </span>
          </div>

        </div>
      </b-tab>


      <b-tab title="Documentos Paciente Titulares">

        <div
          v-for="titular in titularesDocs" 
          :key="titular.id"
          class="row p-2 my-3 mx-3" 
          style="border: 1px solid #c9c9c9"
        >

          <div class="row col-12 pb-1" style="border-bottom: 1px solid #c9c9c9">
            <h5 class="col-6">{{ titular.nombres }}</h5>
          </div>

          <div class="col-12">

            <LoadFileInput
              label="Cedula de identidad"
              v-model="titular.cedulaFile"
              :urlFile="titular.urlIdentificacion"
            />
            

            <span v-if="stDataCita.cobertura === '2'">
              <hr>

              <LoadFileInput
                label="Carnet ISSPOL"
                v-model="titular.carnetIsspol"
                :urlFile="titular.urlCarnetIsspol"
              />

            </span>


            <span v-if="stDataCita.cobertura === '3'">
              <hr>

              <LoadFileInput
                label="Carnet ISSFA"
                v-model="titular.carnetIssfa"
                :urlFile="titular.urlCarnetIssfa"
              />

            </span>
            
            <!-- <LoadFileInput
              label="Carnet Discapacidad"
              v-model="titular.carnetDiscapacidad"
              :urlFile="titular.urlCarnetDiscapacidad"
            /> -->
            
          </div>
        </div>
      </b-tab>
    </b-tabs>
    
  </div>
  
</template>

<script>
import { mapState }        from "vuex";
import axios               from "axios";
import { LoadFileInput }   from '@/shared/components';
import rutas               from "@/assets/utils/rutas.json";
import { fileService }     from "@/shared/services";
import { personasService } from "../../../admision/services";
import { citasService }    from "../../services";

export default {

  components: {
    LoadFileInput
  }, 


  created() {
    this.loadDataCita();
  },


  data(){
    return {
      titularesDocs: [],

      citaDocs:{
        mspPaciente            : null,
        mspTitular1            : null,
        mspTitular2            : null,
        mspTitular3            : null,
        tirilla                : null,
        derivacion             : null,
        solicitudImagen        : null,
        solicitudLaboratorio   : null,
        solicitudProcedimiento : null,
        f007                   : null,
        otrosDocs              : null,
      },

      urlCitaDocs:{
        urlMspPaciente : null,
        urlMspTitular1 : null,
        urlMspTitular2 : null,
        urlMspTitular3 : null,
        urlTirilla     : null,
        urlDerivacion  : null,
        urlSolicitudImagen : null,
        urlSolicitudLaboratorio : null,
        urlSolicitudProcedimiento : null,
        urlF007 : null,
        urlOtrosDocs : null
      },

      isMspLoadingByField: {
        mspPaciente: false,
        mspTitular1: false,
        mspTitular2: false,
        mspTitular3: false,
      },

    }
  },

  methods: {
    isMspLoading(targetField) {
      return Boolean(this.isMspLoadingByField?.[targetField]);
    },


    async loadDataCita(){

      this.tokenCita = this.$route.params.token;
      if(!this.tokenCita) return;

      const responseCita = await citasService.getByToken(this.tokenCita);

      if(!responseCita){
        console.error('Cita no encontrada');
        return;
      }

      const documentosCita = {
        urlMspPaciente            : responseCita.urlsMspPaciente,
        urlMspTitular1            : responseCita.urlsMspTitular1,
        urlMspTitular2            : responseCita.urlsMspTitular2,
        urlMspTitular3            : responseCita.urlsMspTitular3,
        urlTirilla                : responseCita.urlCodigoDer,
        urlDerivacion             : responseCita.urlDerivacion,
        urlSolicitudImagen        : responseCita.urlSolImgDer,
        urlSolicitudLaboratorio   : responseCita.urlSolLabDer,
        urlSolicitudProcedimiento : responseCita.urlSolProcDer,
        urlF007                   : responseCita.url007Recibido,
        urlOtrosDocs              : responseCita.urlOtrosDocumentos
      }

      this.urlCitaDocs = documentosCita;
    },

    
    async prepararDataPacienteTitulares() {

      if(!this.stDataPaciente) return;
      const idPacientePersona = this.stDataPaciente?.persona.id;

      const pacienteYTitularesIds = [];

      if(this.stDataTitulares){
        const idsTitularesPersona = this.stDataTitulares?.map(t => t.idPersona);
        pacienteYTitularesIds.push(...idsTitularesPersona);
      }

      if(!pacienteYTitularesIds.includes(idPacientePersona)){
        pacienteYTitularesIds.unshift(idPacientePersona);
      }

      const responsePersonas = await Promise.all(
        pacienteYTitularesIds.map( id =>  personasService.getAll({ idPersona: id }))
      );

      const responsePersonasFlat = responsePersonas.flat();

      const mapPersonasDocs = responsePersonasFlat.map( p => ({
        idPersona         : p.id,
        tokenPersona      : p.token,
        identificacion    : p.identificacion,
        nombres           : `${p.identificacion} - ${p.primerApellido} ${p.primerNombre}`,
        urlIdentificacion : p.urlIdentificacion,
        urlCarnetIssfa    : p.urlCarnetIssfa,
        urlCarnetIsspol   : p.urlCarnetIsspol,
        urlCarnetDiscapacidad: p.urlCarnet,
        cedulaFile         : null,
        carnetIssfa        : null,
        carnetIsspol       : null,
        carnetDiscapacidad : null
      }));

      this.titularesDocs = mapPersonasDocs;
    },


    redirectToMSP() {
      const url = "https://coberturasalud.msp.gob.ec/";
      window.open(url, "_blank");
    },

    formatFechaMsp(date = new Date()) {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    },

    base64ToPdfFile(base64, fileName) {
      const cleanBase64 = base64.includes(',')
        ? base64.split(',').pop()
        : base64;

      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i += 1) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      return new File([blob], fileName, { type: 'application/pdf' });
    },

    showToast(message, variant = "success") {
      if (this.$bvToast) {
        this.$bvToast.toast(message, {
          title: "MSP",
          variant,
          solid: true,
          autoHideDelay: 4000,
        });
        return;
      }

      if (this.$swal) {
        this.$swal.fire({
          icon: variant === "danger" ? "error" : "success",
          title: "MSP",
          text: message,
        });
      }
    },

    async solicitarMspAsync(cedula, fecha) {
      const query = `
        mutation {
          solicitarCoberturaSaludAsync(identificacion: "${cedula}", fecha: "${fecha}") {
            status
            message
            jobId
            jobStatus
          }
        }
      `;
      const response = await axios.post(rutas.axios + "api", { query });
      return response?.data?.data?.solicitarCoberturaSaludAsync;
    },

    async obtenerEstadoMspAsync(jobId) {
      const query = `
        mutation {
          obtenerEstadoCoberturaSaludAsync(jobId: "${jobId}") {
            status
            message
            jobId
            jobStatus
            pdfBase64
            data
          }
        }
      `;
      const response = await axios.post(rutas.axios + "api", { query });
      return response?.data?.data?.obtenerEstadoCoberturaSaludAsync;
    },

    async esperarResultadoMsp(jobId, { maxAttempts = 60, intervalMs = 3000 } = {}) {
      for (let i = 0; i < maxAttempts; i += 1) {
        const estado = await this.obtenerEstadoMspAsync(jobId);
        const requestStatus = estado?.status;
        const jobStatus = estado?.jobStatus;

        if (requestStatus !== "success") {
          throw new Error(estado?.message || "No se pudo consultar estado MSP");
        }

        if (jobStatus === "success") {
          return estado;
        }

        if (jobStatus === "error") {
          throw new Error(estado?.message || "Error al procesar MSP");
        }

        await new Promise((resolve) => setTimeout(resolve, intervalMs));
      }

      throw new Error("Tiempo de espera agotado consultando MSP");
    },

    async onMspAutomaticoFor(cedula, targetField) {
      if (!cedula) {
        this.showToast("Cédula no disponible", "danger");
        return;
      }

      if (this.isMspLoading(targetField)) return;

      this.$set(this.isMspLoadingByField, targetField, true);

      const fecha = this.formatFechaMsp();

      try {
        this.showToast("MSP en proceso, puede tardar unos segundos...", "success");

        const job = await this.solicitarMspAsync(cedula, fecha);
        const jobStatus = job?.status;
        const jobMessage = job?.message || "Error al encolar MSP";
        const jobId = job?.jobId;

        if (jobStatus !== "success" || !jobId) {
          this.showToast(`No se pudo iniciar MSP: ${jobMessage}`, "danger");
          return;
        }

        const payload = await this.esperarResultadoMsp(jobId, {
          maxAttempts: 60,
          intervalMs: 3000,
        });

        if (!payload?.pdfBase64) {
          this.showToast(`No se pudo generar MSP: ${payload?.message || "Sin PDF generado"}`, "danger");
          return;
        }

        const fileName = `MSP_${cedula}_${fecha}.pdf`;
        const pdfFile = this.base64ToPdfFile(payload.pdfBase64, fileName);

        this.$set(this.citaDocs, targetField, pdfFile);
        const targetFieldToUrlField = {
          mspPaciente: "urlMspPaciente",
          mspTitular1: "urlMspTitular1",
          mspTitular2: "urlMspTitular2",
          mspTitular3: "urlMspTitular3",
        };
        const urlField = targetFieldToUrlField[targetField];

        if (!urlField) {
          this.showToast("Campo MSP no reconocido", "danger");
          return;
        }

        if (!this.tokenCita) {
          this.showToast("MSP automático generado. Se guardará al finalizar la cita.", "success");
          return;
        }

        const oldUrl = this.urlCitaDocs?.[urlField] || null;
        const uploadedUrl = await fileService.upload("msp", pdfFile, cedula, oldUrl);

        if (!uploadedUrl) {
          this.showToast("MSP generado, pero no se pudo subir el archivo al servidor", "danger");
          return;
        }

        const responseUpdate = await citasService.updateByToken(this.tokenCita, {
          [urlField]: uploadedUrl,
        });

        if (!responseUpdate) {
          this.showToast("MSP subido, pero no se pudo guardar en la cita", "danger");
          return;
        }

        this.$set(this.urlCitaDocs, urlField, uploadedUrl);
        this.$set(this.citaDocs, targetField, null);
        this.showToast("MSP automático generado y guardado en la cita", "success");
      } catch (error) {
        const errorMessage = error?.response?.data?.errors?.[0]?.message || error?.message || "Error desconocido";
        this.showToast(`No se pudo generar MSP: ${errorMessage}`, "danger");
      } finally {
        this.$set(this.isMspLoadingByField, targetField, false);
      }
    },


    validationFormDocumentos(){

      const errors = [];

      if(this.esDerivado){

        if(this.tipoServicios.includes('2') && !this.citaDocs.solicitudImagen && !this.urlCitaDocs.urlSolicitudImagen)
          errors.push('Documento solicitud imagen es obligatorio');

        if(this.tipoServicios.includes('3') && !this.citaDocs.solicitudLaboratorio && !this.urlCitaDocs.urlSolicitudLaboratorio)
          errors.push('Documento solicitud laboratorio es obligatorio');

        if(this.tipoServicios.includes('4') && !this.citaDocs.solicitudProcedimiento && !this.urlCitaDocs.urlSolicitudProcedimiento)
          errors.push('Documento solicitud procedimiento es obligatorio');
      }

      if(errors.length){
        this.$swal.fire({
          title: 'Datos incompletos!',
          icon: 'error',
          text: errors
        });

        return false;
      }

      return true;
    }
  },


  computed: {
    ...mapState({
      stDataCita     : state => state.citas?.ingresoCitas?.dataInfoCita,
      stDataPaciente : state => state.citas?.ingresoCitas?.dataInfoCita?.paciente,
      stDataTitulares: state => state.citas?.ingresoCitas?.dataTitulares
    }),


    canViewDocumentosCita(){
      return this.stDataCita?.cobertura !== "5" 
    },

    hasActiveMspLoading() {
      return Object.values(this.isMspLoadingByField || {}).some(Boolean);
    },

    canViewDocumentosDerviacion(){
      return this.stDataCita?.esDerivado 
    },


    tipoServicios(){
      return this.stDataCita?.tipoServicios
    },

    esDerivado(){
      return this.stDataCita?.esDerivado
    }
    
  },


  watch: {

    tipoServicios: {
      handler(){
        this.citaDocs.solicitudImagen = null;
        this.citaDocs.solicitudLaboratorio = null;
        this.citaDocs.solicitudProcedimiento = null;
      }
    },

    stDataPaciente: {
      deep: true,
      immediate: true,
      handler() {
        this.prepararDataPacienteTitulares()
      }
    },

    stDataTitulares: {
      deep: true,
      immediate: true,
      handler() {
        this.prepararDataPacienteTitulares()
      }
    },


    titularesDocs:{
      deep: true,
      handler(newValue) {
        this.$store.commit('setDataDocsPersonas', newValue);
      }
    },


    citaDocs:{
      deep:true,

      handler(newValue){

        const docsCita = {
          ...newValue,
          ...this.urlCitaDocs
        }

        this.$store.commit('setDataDocsCita', docsCita);
      }
    }

  },

}
</script>
